import { css } from 'react-emotion'

const styles = {
  addProjectMsg: css({
    color: 'rgb(170, 170, 170)',
    marginBottom: '20px',
    justifyContent: 'center',
    display: 'flex',
  })
}

export default styles



// WEBPACK FOOTER //
// ./src/Components/SideBarLeft/MainProjectsStyles.js